import * as React from 'react';
export const pingSvg = React.forwardRef(function pingSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.881 3.381a.875.875 0 0 1 1.238 0C9.319 4.583 9.875 6.326 9.875 8s-.555 3.418-1.756 4.619A.875.875 0 0 1 6.88 11.38c.8-.798 1.245-2.054 1.245-3.38S7.68 5.417 6.881 4.619a.875.875 0 0 1 0-1.238Zm3.5-3a.872.872 0 0 1 1.238 0C13.569 2.333 14.5 5.201 14.5 8c0 2.799-.93 5.668-2.881 7.619a.872.872 0 0 1-1.238 0 .875.875 0 0 1 0-1.238c1.55-1.549 2.369-3.93 2.369-6.381s-.82-4.833-2.369-6.381a.875.875 0 0 1 0-1.238Z',
    }),
  );
});
pingSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ping = {
  category: 'icon',
  colorable: true,
  name: 'ping',
  svg: pingSvg,
};
